import { micromark } from 'micromark';
import { classNames } from '~/utils/styles';

import type { MarkdownProps } from './Markdown.types';

export const Markdown = ({ className, markdown }: MarkdownProps) => (
  <div
    className={classNames(
      '[&>p:not(:last-child)]:mb-2 [&>p>br]:mb-4 [&>ul]:list-disc [&>ul]:pl-6 [&>ul:not(:last-child)]:mb-4',
      className,
    )}
    // oxlint-disable-next-line react/no-danger -- This is a markdown component and it's expected to render HTML
    dangerouslySetInnerHTML={{ __html: micromark(markdown) }}
  />
);
